import styled from "styled-components";

export const BodyContainer = styled.section`
  width: ${({ theme }) => theme.desktop};
  max-width: 100%;
  margin: 0 auto auto;

  position: relative;
`;
